import { useState } from 'react';
import { NJButton, NJMenu } from '@engie-group/fluid-design-system-react';
import { OPTIMISATION_TYPES } from '@shared/size2mix-shell';
import type { OptimisationType } from './types';

/** Close the menu on click without keeping a selected item. */
const NO_SELECTION: number[] = [];

/**
 * Production `OptimisationCreateMenu`: primary NJButton + attached primary NJIconButton chevron opening an NJMenu of horizons.
 * In Nemo the choice opens a right-side creation form; here it creates the optimisation directly (form out of scope).
 */
export default function CreateOptimisationMenu({ onCreate }: { onCreate: (type: OptimisationType) => void }) {
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen((o) => !o);
    return (
        <NJMenu.Root>
            <NJMenu.Anchor>
                <div style={{ display: 'flex' }}>
                    <NJButton label="Créer une nouvelle optimisation" scale="md" onClick={toggle} />
                    <span style={{ display: 'inline-flex', borderLeft: '1px solid var(--nj-semantic-color-border-neutral-inverse-default, #fff)' }}>
                        <NJButton
                            label=""
                            aria-label="Choisir le type d'optimisation"
                            icon={isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                            scale="md"
                            onClick={toggle}
                            style={{ paddingInline: 4 }}
                        />
                    </span>
                </div>
            </NJMenu.Anchor>
            <NJMenu.Dropdown style={{ minWidth: 200 }}>
                <NJMenu.Selection selectedIndexes={NO_SELECTION}>
                    <NJMenu.Group>
                        {OPTIMISATION_TYPES.map((type) => (
                            <NJMenu.Item
                                key={type}
                                onClick={() => {
                                    setIsOpen(false);
                                    onCreate(type);
                                }}
                            >
                                {type}
                            </NJMenu.Item>
                        ))}
                    </NJMenu.Group>
                </NJMenu.Selection>
            </NJMenu.Dropdown>
        </NJMenu.Root>
    );
}
